import { render, staticRenderFns } from "./batchApplication.vue?vue&type=template&id=91bae488"
import script from "./batchApplication.vue?vue&type=script&lang=js"
export * from "./batchApplication.vue?vue&type=script&lang=js"
import style0 from "./batchApplication.vue?vue&type=style&index=0&id=91bae488&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports